import React, { memo, useState, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import NEXUS_CONST from '../../common/constants';
const style = {
   
};
export const MenuCard = memo(function Card({ id, title, moveCard, findCard, deleteCard, saveCard, iconCls, index, isActive, setActiveItem, visible, setVisibility, cloneItem, updateEditActive, editActive}) {
    //const [showEdit, setShowEdit] = useState(false)
    const [showIcon, setShowIcon] = useState(false)
    const inputRef1 = useRef(null);
    const [val, setVal] = useState(title);
    const [iconActive, setIconActive] = useState(iconCls);

    const defaultMenu = ['performance', 'safety', 'quality', 'delivery', 'inventory', 'cost', 'people' ]
    
    const originalIndex = findCard(id).index;
    const [{ isDragging }, drag] = useDrag(() => ({
        type: NEXUS_CONST.DND_TYPES.MENU_CARD,
        item: { id, originalIndex },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const { id: droppedId, originalIndex } = item;
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                
                moveCard(droppedId, originalIndex);
            }
        },
    }), [id, originalIndex, moveCard]);
    const [, drop] = useDrop(() => ({
        accept: NEXUS_CONST.DND_TYPES.MENU_CARD,
        canDrop: () => false,
        hover({ id: draggedId }) {
            if (draggedId !== id) {
                const { index: overIndex } = findCard(id);
              
                moveCard(draggedId, overIndex);
            }
        },
    }), [findCard, moveCard]);
    const opacity = isDragging ? 0 : 1;

    const iconList = () => {
        
        return NEXUS_CONST.MENU_ICONS.map((icon, i) => <span key={i} className={`icon ${icon}-icon ${icon === iconActive ? "active-border":""}`} onClick={() => setIconActive(icon)} ></span>)
    }

    //const updateMenu = () => { setShowEdit(false); saveCard({ id: id, title: val, iconCls: '' }) }

    const editCard = () => {

       //setShowEdit(!showEdit);
        inputRef1.current.focus();
    }



    const updateVisibility = () => {

        setVisibility(id)

    }
    let showEdit = false;
    let menuCardCls = "node ";

    if (showEdit)
        menuCardCls = "node edit-node"

    if (editActive == index) {
        showEdit = true
        menuCardCls = "node edit-node"
    }
    


    if (showEdit && showIcon)
        menuCardCls = "node choose-icon edit-node"

    if (isActive)
        menuCardCls = menuCardCls + ' active'

    let iconActiveCls = '';
    if (showIcon)
        iconActiveCls = 'active-border' 

    let isCustomMenu = (defaultMenu.indexOf(id) == -1);

    const editMenuTpl = () => {
        if (showEdit) {
            let closeIcon = <span title="Close edit" className="edit-widget-close fa-nexus-icons" onClick={()=>updateEditActive(null)}><i className="fas fa-times"></i></span>
            let cloneIcon = <span title="Clone" className="clone-icon-adj fa-nexus-icons" onClick={()=>cloneItem(index)}><i className="fas fa-clone"></i></span>
           // if (!isCustomMenu) {
                return <>
                    <span title={visible ? 'Active' : "Inactive"} className="visibility-icon-adj primary-txt-clr">{visible ? <i onClick={updateVisibility} className="fas fa-eye fa-nexus-icons"></i> : <i onClick={updateVisibility} className="fas fa-eye-slash"></i>}</span>
                    {cloneIcon}
                    {closeIcon}
                </>
            //}
           // else return <>{cloneIcon}{closeIcon}</>
             
        } else return <>
            {!visible && <span title="Inactive" className="primary-txt-clr"> <i  className="fas fa-eye-slash"></i></span> }
        <span className="icon edit" onClick={() => updateEditActive(index)}></span>
        </>
        
    }

    return (<li key={index} onClick={()=>setActiveItem(index)} className={menuCardCls} ref={(node) => drag(drop(node))} style={{ ...style, opacity }}>

        
            <div className="node-wrap">
                <span className="icon drag"></span>
            <span className={`icon node-icon ${iconCls}-icon ${iconActiveCls}`} onClick={() => setShowIcon(!showIcon)}></span>
            <input type="text" value={val} placeholder="Add title" disabled={!showEdit} ref={inputRef1} onChange={(e) => setVal(e.target.value)} />
           
            {editMenuTpl()}
            </div>
            <div className="icon-wrap">
            {iconList()}
            </div>

        {showEdit && <div className="button-wrap ">
            <button className="btn primary-btn" onClick={() => { updateEditActive(null); saveCard({ id: id, title: val, iconCls: iconActive }) }}>Save</button>
            {/*isCustomMenu && <button className="btn secondary-btn" onClick={() => deleteCard(id)}>Delete</button>
            */}
            <button className="btn secondary-btn" onClick={() => deleteCard(id)}>Delete</button>
        </div>
        }
    </li>);
});
